import { Card } from "@finway-group/shared/lib/models"
import { Badge } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"

import UserImage from "Components/UserImage"
import { useEmployeeById } from "Shared/hooks/employee.hooks"

interface FirstNameInterface {
    card: Card
}

export const FirstNameDisplay = ({ card }: FirstNameInterface) => {
    const { t } = useTranslation()

    const user = useEmployeeById(card.user)
    const expiringSoon = moment(card.expirationDate).isBetween(moment().subtract(1, "w"), moment().add(2, "w"), undefined, "[]")

    return (
        <div className="flex items-center image-loader gap-10">
            {user && <UserImage user={user} size="large" />}
            <div className="flex flex-col truncate">
                <div className="flex items-center mb-3">
                    <p className="leading-tight mb-0 truncate">
                        <span className="font-bold">{user?.getFullName()}</span>
                        <span className="ml-4">({t(`label:cards.type.${card.cardType.toLowerCase()}`)})</span>
                    </p>
                    {expiringSoon && <Badge className="ml-8 h-20 ant-badge-warning">{t("label:expires_soon")}</Badge>}
                </div>
                <p className="text-xs text-text leading-none mb-0 truncate">{`*** ${card.last4Digits} (${card.cardName})`}</p>
            </div>
        </div>
    )
}
